export default __webpack_public_path__ + "static/media/withdraw.fe6342d0.svg";